(function () {
    'use strict';

    angular
        .module('app')
        .controller('ItemCopyErrorDialogCtrl', ItemCopyErrorDialogCtrl);

    ItemCopyErrorDialogCtrl.$inject = ['DialogInstance', 'ItemService', 'errorText', 'itemProducingError', 'itemCopyState'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing an item copy error, and prompting the user whether they want to continue copying items.
     *
     * @param {string} errorText
     * @param {object} itemProducingError
     * @param {array} itemCopyState
     */
    function ItemCopyErrorDialogCtrl(DialogInstance, ItemService, errorText, itemProducingError, itemCopyState) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.itemType = 'Item';
        vm.errorText = errorText;
        vm.itemProducingError = itemProducingError;
        vm.itemLink = null;

        activate();

        function activate() {
            if (!_.isNil(itemProducingError)) {
                var itemMetaData = ItemService.getItemTypeMetaData(itemProducingError);
                if (!_.isNil(itemMetaData)) {
                    vm.itemType = itemMetaData.singular;
                } else if (!_.isNil(itemProducingError.Type)) {
                    vm.itemType = itemProducingError.Type;
                }

                vm.itemLink = ItemService.getItemLink(itemProducingError);
            }
        }

        function ok() {
            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
